import { FETCH_REDEEM, ADD_REDEEM, EDIT_REDEEM, DESTROY_REDEEM, DELETE_REDEEM } from "../actionTypes";

export const fetchRedeem = redeems => ({
    type: FETCH_REDEEM,
    redeems
});

export const addRedeem = redeem => ({
    type: ADD_REDEEM,
    redeem
});

export const editRedeem = redeem => ({
    type: EDIT_REDEEM,
    redeem
});

export const deleteRedeem = id => ({
    type: DELETE_REDEEM,
    id
});

export const destroyRedeem = key => ({
    type: DESTROY_REDEEM,
    key
});